<template>
  <div
    class="discover-home"
    data-test="page-discover">
    <!--  -->
    <div v-if="loading">
      <div class="container">
        <banner-loader/>
        <trailer-loader/>
        <show-loader/>
      </div>
    </div>
    <div v-else>
      <featured-carousel
        :key="0"
        :featured-images="featured_items"
        :bucket="featured_bucket"
        :data-segment-uuid="featured_bucket.uuid"
        class="bundle-item"/>
      <div
        v-if="category_podcasts.length"
        class="buckets"
      >
        <template v-for="(next_category, index) in category_podcasts">
          <div
            v-if="next_category.items && next_category.items.length && next_category.bucket_type !== 'featured'"
            :key="index"
            :data-segment-uuid="next_category.uuid"
            :style="{zIndex: index}"
            class="bundle-item with-padding"
          >
            <podcast-trailer-list
              v-if="next_category.bucket_type == 'trailer'"
              :key="index"
              :bucket="next_category"
              class="m-t-2"
              @play="onTrailerPlay"
            />
            <cl-list
              v-if="next_category.bundle_uuid === 'continue-listening'"
              :key="index"
              :bucket="next_category"
              :heading="next_category.name"
              data-test="bucket-continuelistening"
            />

            <podcast-list
              v-if="next_category.bucket_type != 'trailer' && next_category.bucket_type != 'featured' && next_category.bundle_uuid != 'user-demographic-categories' && next_category.bundle_uuid != 'continue-listening' && next_category.items && next_category.items.length"
              ref="continueList"
              :key="index"
              :see_all="next_category.bundle_uuid === 'new-releases'"
              :see_all_link="'/library/podcast-episodes'"
              :bucket="next_category"
              :has-hover-state="true"
              class="continue_list"
            />

            <podcast-list
              v-if="next_category.bundle_uuid === 'user-demographic-categories' && next_category.items && next_category.items.length"
              :key="index"
              :bucket="next_category"
              :has-hover-state="true"
              :see_all="next_category.bundle_uuid === 'new-releases'"
              :see_all_link="'shows/latest'"
            />
          </div>
        </template>
      </div>
      <el-alert
        v-show="!category_podcasts.length"
        :closable="false"
        data-test="noitem-alert"
        class="container"
        title="No items available on discover page"
        type="warning"
        show-icon
        center
      />
      <episode-card-carousel
        v-if="episodes && episodes.length"
        :key="category_podcasts.length"
        :episodes-list="episodes" />
      <el-row
        v-show="!loading && category_podcasts.length"
        class="all-categories">
        <router-link
          v-button-event="{buttonText: 'See All Categories', buttonLink: 'categories_all'}"
          to="/listen/category"
          class="el-button btn-transparent large m-b">
          See All Categories
        </router-link>
      </el-row>
      <UpgradeToPremium v-show="!loading && category_podcasts.length && showPremiumBanner" />
    </div>
    <WelcomeToPremium
      v-if="shouldShowWelcomeToPremium"
      :show="shouldShowWelcomeToPremium"
      @closeWelcomeModal="onClosedWelcomeModal"
    />
  </div>
</template>

<script>
// :class="`bundle-item${!(next_category.bucket_type === 'trailer' || next_category.bundle_uuid === 'continue-listening') ? ' can-hover' : ''}`"
import * as log from 'loglevel';
import Podcast from '../../services/Podcast';
import PlaybackService from '../../services/PlaybackService';
import UserService from '../../services/User';
import EpisodeService from '../../services/Episode';
import Event from '../../services/PlayerEvent';
import FeaturedCarousel from '../../components/FeaturedCarousel';
import UpgradeToPremium from '../../components/UpgradeToPremium';
import PodcastTrailerList from '../../components/PodcastTrailerList';
import PodcastList from '../../components/PodcastList';
import CLList from '../../components/CLList';
import loader from '../../components/Loader';
import BannerLoader from '../../components/loaders/BannerLoader';
import TrailerLoader from '../../components/loaders/TrailerLoader';
import ShowLoader from '../../components/loaders/ShowLoader';
import imgPlaceholder from '../../assets/images/placeholder.png';
import EditorialCarousel from '../../components/EditorialCard';
import EpisodeCardCarousel from '../../components/EpisodeCardCarousel';
import WelcomeToPremium from '../../components/WelcomeToPremium';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'DiscoverHome',
  components: {
    loader,
    'featured-carousel': FeaturedCarousel,
    'podcast-trailer-list': PodcastTrailerList,
    'podcast-list': PodcastList,
    'banner-loader': BannerLoader,
    'trailer-loader': TrailerLoader,
    'show-loader': ShowLoader,
    'editorial-carousel': EditorialCarousel,
    UpgradeToPremium,
    'cl-list': CLList,
    EpisodeCardCarousel,
    WelcomeToPremium,
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Home',
      loading: false,
      imgPlaceholder,
      category_podcasts: [],
      featured_podcasts: null,
      trailers: [],
      episodes: [],
      podcastObj: new Podcast(),
      episode_service: new EpisodeService(),
      playbackService: new PlaybackService(),
      episodes_listened: [],
      user_service: new UserService(),
      bundle_id: this.$route.params.bundle_id,
      mobile_width: 567,
      page_width: window.innerWidth,
      featured_bucket: { items: [] },
      featured_items: [],
      // Continue listening bucket index
      continue_listening_index: -1,
      // Continue listening selected index
      continue_listening_selected_index: -1,
      show_carousel: true,
      // Carousel selected index
      clicked_index: -1,
      carousel_loaded: false,
      selected_carousel_index: 0,
      selected_cell: null,
      cont_list: null,
      eventProvider: new Event(),
      newSubscription: false,
    };
  },
  computed: {
    is_logged_in() {
      return this.$store.getters.user || false;
    },
    isPremiumMember() {
      return this.$store.getters.is_subscribed || false;
    },
    showPremiumBanner() {
      const { user } = this.user_service;

      if (!user) {
        return true;
      }

      if (user && !user.is_subscribed) {
        return true;
      }

      return false;
    },
    shouldShowWelcomeToPremium() {
      const { user } = this.$store.getters;

      return user && user.is_subscribed && this.newSubscription;
    },
  },
  watch: {
    '$store.getters.episode': (newVal, oldVal) => {
      if (newVal.uuid === oldVal.uuid || this.continue_listening_index < 0) {
        log.info('First episode played: ');
        // return;
      }
      // TODO: re-order continue listening bucket items
      // this.category_podcasts[this.continue_listening_index].items.forEach(item => item.show_temp_title = true)
      // this.continue_listening_selected_index = this.category_podcasts[this.continue_listening_index].items.findIndex(item => item.uuid === newVal.uuid)
      // if(this.continue_listening_selected_index > -1) {
      //   //this.changeContListeningAttributes(newVal.title,newVal.pogress)
      //   let obj = this.category_podcasts[this.continue_listening_index].items.splice(this.continue_listening_selected_index , 1)[0]
      //   this.category_podcasts[this.continue_listening_index].items.unshift(obj)
      // }
    },
    '$store.getters.continueListeningPlaylist': {
      handler(newVal) {
        // log.info('CL Bucket Updated');
        // log.info(newVal);
        if (this.category_podcasts && this.continue_listening_index > -1) {
          this.$set(this.category_podcasts[this.continue_listening_index], 'items', newVal);
        }
        // this.category_podcasts[this.continue_listening_index].items = newVal;
      },
      deep: true,
    },
  },
  mounted() {
    this.setMetaInformation('Luminary Web Player - Listen to Podcasts Online', 'Discover new episodes and shows with fully-customized podcast suggestions. Easily navigate playlists & seamlessly pick up wherever you left off in any episode!');

    if (this.bundle_id) {
      if (this.bundle_id.split('-').length < 4) {
        this.$router.push('not-found/404');
        return;
      }
      this.loadBundlesById();
    } else {
      this.loadPodcasts();
    }
    // This event is fired on logout
    // Remove continuous listening and demographics categorized buckets from page on logout
    const ctx = this;
    window.eventBus.$on('hide-player', () => {
      ctx.removeContinueListeningPlaylist(); // remove continuous playlist on logout
      ctx.removeDemographicCategories(); // remove demographic categories on logout
    });

    if (this.$route.query.newSubscription) {
      this.newSubscription = true;
    }
  },
  destroyed() {
    this.setMetaInformation();
  },
  beforeRouteLeave(to, from, next) {
    this.triggerBundleBrowseEvent();
    next();
  },
  methods: {
    onClosedWelcomeModal() {
      this.newSubscription = false;

      const query = Object.assign({}, this.$route.query);
      delete query.newSubscription;
      this.$router.replace({ query });
    },
    changeContListeningAttributes(title) {
      // Change title forcefully
      document.querySelector('.continue_list .swiper-slide-active .header').innerHTML = title;
      // Change progress forcefully
      // document.querySelector(".continue_list .swiper-slide-active .el-progress-bar__inner").setAttribute(`style` , `width:${prog}%`)
    },
    getDiscoverDataFromLocalStorage() {
      if (!this.is_logged_in) {
        return;
      }
      this.category_podcasts = this.$store.getters.discover;
      // Store featured items in separate variable
      const index = this.category_podcasts.findIndex(item => item.bucket_type === 'featured');
      if (index > -1) {
        this.featured_bucket = this.category_podcasts[index];
        this.featured_items = this.category_podcasts[index].items;
      }
      // If 3 items, then duplicate items to resolve spacing issues while dragging on larger screens.
      if (this.featured_items.length === 3) {
        this.featured_items = this.featured_items.concat(this.featured_items);
      }
      // Find index of continue listening bucket in discover bundle
      this.continue_listening_index = this.category_podcasts.findIndex(item => item.bucket_type === 'podcast' && item.bundle_uuid === 'continue-listening');
    },
    loadPodcasts() {
      if (!this.category_podcasts.length) this.loading = true;

      this.podcastObj.loadHomeCategories().then((resp) => {
        this.category_podcasts = resp;
        // Temporary Limit data items in each category bucket
        const episodes = [];
        this.category_podcasts.forEach((item, index) => {
          item.items = item.items.slice(0, 25);
          if (item.bucket_type === 'episode') {
            // Extract Episodes to display in seperate carousel
            episodes.push(...item.items);
            this.category_podcasts.splice(index, 1);
          }
        });
        this.episodes = episodes;
        this.setFeaturedBucket();
        this.separateTrailers();
        if (this.is_logged_in) {
          this.loadDynamicBuckets();
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        log.error(err.message);
      });
    },
    setFeaturedBucket() {
      const index = this.category_podcasts.findIndex(item => item.bucket_type === 'featured');
      if (index > -1) {
        this.featured_bucket = this.category_podcasts[index];
        this.featured_items = this.category_podcasts[index].items;
      }

      // If 3 items, then duplicate first element
      if (this.featured_items.length === 3) {
        this.featured_items = this.featured_items.concat(this.featured_items);
      }
    },
    loadDynamicBuckets() {
      this.loadContinueListeningBucket();
      this.loadRecommendedPodcastsBucket();
    },
    loadContinueListeningBucket() {
      this.podcastObj.loadContinueListeningBucket().then((resp) => {
        if (resp && resp.length) {
          const clBucket = resp[0];
          this.continue_listening_index = this.category_podcasts.findIndex(item => item.uuid === 'continue-listening');
          if (this.continue_listening_index > -1) {
            this.$set(this.category_podcasts, this.continue_listening_index, clBucket);
            this.mapContListening();
            this.integrateContinueListeningPlaylist();
          }
        }
      });
    },
    loadRecommendedPodcastsBucket() {
      this.podcastObj.loadRecommendedPodcastsBucket().then((resp) => {
        if (resp && resp.length) {
          const bucket = resp[0];
          const bucketIndex = this.category_podcasts.findIndex(item => item.uuid === 'recommended-podcasts');
          if (bucketIndex > -1) {
            this.$set(this.category_podcasts, bucketIndex, bucket);
          }
        }
      });
    },
    mapContListening() {
      const clBucketItems = this.playbackService.mapContListening(this.category_podcasts[this.continue_listening_index].items);
      this.category_podcasts[this.continue_listening_index].items = clBucketItems;
      this.loading = false;
    },
    loadBundlesById() {
      this.loading = true;
      if (this.is_logged_in) {
        // Show cont listening
      }
      this.podcastObj.loadByBundleId(this.bundle_id)
        .then((resp) => {
          this.category_podcasts = resp || [];
          const index = this.category_podcasts.findIndex(item => item.bucket_type === 'featured');
          this.featured_items = index > -1 ? this.category_podcasts[index].items : [];
          this.loading = false;
        })
        .catch((err) => { log.warn(err.message); this.loading = false; });
    },
    integrateContinueListeningPlaylist() {
      if (this.category_podcasts && this.category_podcasts.length) {
        const contListIndex = this.category_podcasts.findIndex(item => item.bucket_type === 'podcast' && item.bundle_uuid === 'continue-listening');
        if (contListIndex !== -1) {
          this.$store.dispatch('setContinueListeningPlaylist', this.category_podcasts[contListIndex].items);
        }
      }
    },
    removeContinueListeningPlaylist() {
      if (this.category_podcasts && this.category_podcasts.length) {
        const targetIndex = this.category_podcasts.findIndex(bucket => bucket.uuid === 'continue-listening');
        if (targetIndex > -1 && targetIndex < this.category_podcasts.length) {
          this.category_podcasts[targetIndex].items = [];
        }
      }
    },
    removeDemographicCategories() {
      if (this.category_podcasts && this.category_podcasts.length) {
        const targetIndex = this.category_podcasts.findIndex(bucket => bucket.bundle_uuid === 'user-demographic-categories');
        if (targetIndex > -1 && targetIndex < this.category_podcasts.length) {
          this.category_podcasts[targetIndex].items = [];
        }
      }
    },
    separateTrailers() {
      this.category_podcasts.forEach((podcastBucket, index) => {
        if (podcastBucket.bucket_type === 'trailer') {
          let trailers = index > -1 ? this.category_podcasts[index].items : [];
          trailers = trailers.map((trailer) => {
            trailer.is_playing = false;
            trailer.episode_type = 'trailer';
            return trailer;
          });
          this.category_podcasts[index].items = trailers;
        }
      });
    },
    getBucketByUuid(bucketUuid) {
      return this.category_podcasts.find(item => item.uuid === bucketUuid);
    },
    onTrailerPlay(currentPlaying, buckeetUuid) {
      let bucket;
      if (buckeetUuid) {
        bucket = this.getBucketByUuid(buckeetUuid);
      }

      this.$store.dispatch('setPlaylist', (buckeetUuid && bucket && bucket.items && bucket.items.length) ? bucket.items : []);
    },
    progressPercent(item) {
      return item ? Number(((item.elapsed / item.runtime) * 100).toFixed(2)) : 0;
    },
    listener() {
      this.$eventHub.$on('play-podcast', (evt) => {
        const { playlistType } = this.$store.getters;
        if (playlistType === 'trailers') {
          this.separateTrailers();
          this.category_podcasts.forEach((bucket) => {
            if (bucket.bucket_type === 'trailer') {
              const targetIndex = bucket.items.findIndex(item => item.uuid === evt.uuid);
              if (targetIndex > -1) {
                const obj = {
                  ...bucket.items[targetIndex],
                  is_playing: evt.play,
                };
                this.$set(bucket.items, targetIndex, { ...obj });
              }
            }
          });
        }
      });
    },
    continueListeningPodcastClick() {
      const vm = this;
      this.$eventHub.$on('play-podcast', (evt) => {
        vm.category_podcasts[vm.continue_listening_index].items.forEach((item) => { item.show_temp_title = true; });
        vm.continue_listening_selected_index = vm.category_podcasts[vm.continue_listening_index].items.findIndex(item => item.uuid === evt.uuid);
        if (vm.continue_listening_selected_index > -1) {
          if (evt.play) {
            const obj = vm.category_podcasts[vm.continue_listening_index].items.splice(vm.continue_listening_selected_index, 1)[0];
            obj.show_temp_title = false;
            vm.category_podcasts[vm.continue_listening_index].items.unshift(obj);
          } else {
            log.info('!Play');
            vm.category_podcasts[vm.continue_listening_index].items[vm.continue_listening_selected_index].show_temp_title = true;
          }
        }
      });
    },
    triggerBundleBrowseEvent() {
      const scrollPos = document.body.scrollTop;
      const viewportHeight = document.body.offsetHeight;

      let buckets = document.getElementsByClassName('bundle-item');
      buckets = Array.from(buckets);
      let bucketsSeen = [];
      buckets = buckets.filter(bucket => bucket.offsetTop >= scrollPos && bucket.offsetTop <= (scrollPos + viewportHeight));
      bucketsSeen = buckets.map((bucket) => {
        const uuid = bucket.getAttribute('data-segment-uuid');
        return uuid;
      });

      this.eventProvider.triggerBundleBrowseEvent(bucketsSeen, this.category_podcasts.length);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/variables.scss";
.discover-home {
  .buckets {
    margin-top: 56px;

    @media (max-width: 768px) {
      margin-top: 56px;
      top: 0;
    }
  }

  .bundle-item {
    position: relative;
    &:hover {
      z-index: 5000 !important;

      .podcast-card {
        z-index: 5000;
      }
    }

    &.with-padding {
      .flickity-viewport {
        padding: 80px 0 120px;

        @media (max-width: 768px) {
          padding: 0;
        }
      }

      .list-header {
        margin-bottom: -64px;

        @media (max-width: 768px) {
          margin-bottom: 16px;
        }
      }
    }

    &:not(:first-child) {
      margin-top: -64px;

      @media (max-width: 768px) {
        margin-top: 56px;
      }
    }
  }

  .podcast-trailer .trailer-play {
    margin-bottom :11px !important;
  }
  h4 {
    font-weight: 500 !important;
  }
  .el-alert {
    margin-top:30vh;
  }
  .see-all-categories-button {
    color: $gray;
    border: 1px solid $gray;
  }
  .see-all-categories-button:hover {
    color: #fff !important;
  }
  .img-container {
    height: 427px;
    width: 712px;
    margin-right: 16px;
    > img {
      width: 100%;
      background-position: center;
      background-size: cover;
    }
  }
  .all-categories {
    text-align: center;
    margin: 56px 0;
    .el-button {
      color: $black;
    }
  }
}
@media (max-width : 1024px) {
  .discover-home {
    .img-container {
      // width: 60%;
      width: 591px;
      height: 354px !important;
    }
  }
}
@media (max-width: 768px) {
  .discover-home{
    .img-container {
      // width : 65%;
      width : 507px;
      height: 304px !important;
    }
    .see-all-categories-button{
      margin-top: 38px;
      margin-bottom: 62px;
    }
  }
}
@media (max-width: 576px) {
  .discover-home{
    .img-container {
      height: 284px !important;
      width: 100% !important;
      margin:0 !important;
    }
    .all-categories{
      margin: 32px 0;
    }
  }
}
@media (max-width : 375px) {
  .img-container {
    // width: 100% !important;
    // margin:0 !important;
    height: 225px !important;
  }
}
@media (min-width: 576px) {
  .mt16 {
    margin-top: 16px !important;
  }
}

</style>



// WEBPACK FOOTER //
// app/src/pages/discover/Index.vue